
import React from 'react';
import FooterLogo from './footer/FooterLogo';
import ProductLinks from './footer/ProductLinks';
import CompanyLinks from './footer/CompanyLinks';
import { LegalLinks } from './footer/LegalLinks';
import FooterCopyright from './footer/FooterCopyright';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <FooterLogo />
          <ProductLinks />
          <CompanyLinks />
          <LegalLinks />
        </div>
        
        <FooterCopyright />
      </div>
    </footer>
  );
};

export default Footer;
